<template>
  <div class="langChoose">
    lang choose
  </div>
</template>

<script>
  export default {
    name: 'langChoose',
    data () {
      return {
        msg: ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/langChoose.vue